<template>
  <layout-dashboard-card
    title="라우터 상태조회"
    :value="onlineCount"
    append-string="대"
    :icon="icon"
    :width="350"
    :height="180">
    <template v-slot:extension>
      <div class="card-history-list d-flex justify-center">
        <table>
          <tr>
            <td>불량</td>
            <td class="card-history-list-value">{{ offlineCount }} 대</td>
          </tr>
        </table>
      </div>
    </template>
  </layout-dashboard-card>
</template>

<script>
import LayoutDashboardCard from '@/components/card/LayoutAccentCard.vue';
import Icon from '@/assets/icon_07.svg';
import { mapGetters } from 'vuex';

export default {
  name: 'CardRouterStat',
  components: {
    LayoutDashboardCard,
  },
  data: () => ({
    icon: Icon,
  }),
  computed: {
    ...mapGetters({
      devices: 'devices/devices',
    }),
    onlineCount() {
      return this.devices.reduce(
        (acc, item) => (acc + ((item.router_online === 1) ? 1 : 0)),
        0,
      );
    },
    offlineCount() {
      return this.devices.length - this.onlineCount;
    },
  },
};
</script>

<style scoped>

</style>
